<div class="scale-details">
  <div class="scale-gradient" style="width: 260px">
    <div class="scale-dividers">
      @for (value of elevationValues(); track value) {
        <div>{{ value }}</div>
      }
    </div>
    @if (theme() === 'light') {
      <div
        class="light-gradient"
      ></div>
    }
    @if (theme() !== 'light') {
      <div
        class="dark-gradient"
      ></div>
    }

    <div class="unit-info">
      <div>{{ unitString() }}</div>
    </div>
  </div>
</div>
